<template>
  <div class="mt120">
    <ProcessStep 
      v-for="(step, i) in stepsProcess" :key="i" 
      :number="i" 
      :title="$t('pageProcess.stepsProcess['+i+'].title')"  
      :description="$t('pageProcess.stepsProcess['+i+'].description')"
      :tasks="$t('pageProcess.stepsProcess['+i+'].tasks')"
      :goals="$t('pageProcess.stepsProcess['+i+'].goals')"
      :img="$t('pageProcess.stepsProcess['+i+'].img')"
    />
    <ProcessTestimony />
    <Footer />
    <FooterSmall />
    <scrollBack />
  </div>
</template>

<script>
import ProcessStep from '@/components/process/processStep.vue'
import ProcessTestimony from '@/components/process/processTestimony.vue'
import json from '@/locales/en.json'
import Footer from "@/components/Footer.vue"
import FooterSmall from "@/components/FooterSmall.vue"
import scrollBack from "@/components/scrollBack.vue"

export default {
  name: "Process",
  components: {
    ProcessStep,
    ProcessTestimony,
    Footer,
    FooterSmall,
    scrollBack
  },
  data: function() {
    return {
      stepsProcess: json.pageProcess.stepsProcess
    }
  }
};
</script>

<style lang="scss" scoped>

</style>